/**
 * Purchase Service
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PurchaseOrderReturnItemResultDTO } from './purchaseOrderReturnItemResultDTO';


export interface PurchaseOrderReturnResultDTO { 
    id?: number;
    code?: string;
    poId?: number;
    poCode?: string;
    vendorId?: number;
    vendorCode?: string;
    vendorName?: string;
    warehouseId?: number;
    warehouseCode?: string;
    warehouseName?: string;
    reason?: string;
    status?: PurchaseOrderReturnResultDTO.StatusEnum;
    creationDate?: string;
    lastUpdateDate?: string;
    createdBy?: string;
    lastUpdatedBy?: string;
    items?: Array<PurchaseOrderReturnItemResultDTO>;
}
export namespace PurchaseOrderReturnResultDTO {
    export const StatusEnum = {
        Pending: 'PENDING',
        Approved: 'APPROVED',
        Rejected: 'REJECTED',
        InProgress: 'IN_PROGRESS',
        PartiallyShipped: 'PARTIALLY_SHIPPED',
        FullyShipped: 'FULLY_SHIPPED',
        ReceivedByVendor: 'RECEIVED_BY_VENDOR',
        Completed: 'COMPLETED',
        Cancelled: 'CANCELLED'
    } as const;
    export type StatusEnum = typeof StatusEnum[keyof typeof StatusEnum];
}


